import React, { useRef } from 'react';
import { getPPAId, getPPAIdByOps } from 'api/common';
import { isOpPortal, getPPAChannelId } from 'utils/common';
import { getPPAIdFromLocal, setPPAIdFromLocal } from 'utils/localstore';

const usePPAChanneld = (needFetch = false): [number | string | undefined, boolean] => {
    const isOps = isOpPortal();
    const loading = useRef(false);
    const [item, setItem] = React.useState<string | number | undefined>(getPPAChannelId() || undefined);
    const fetchData = async () => {
        if (loading.current) return;
        try {
            loading.current = true;
            let result: any;
            if (isOps) {
                result = await getPPAIdByOps();
            } else {
                result = await getPPAId();
            }
            if (!result.error) {
                const resData = result?.data?.data || undefined;
                setPPAIdFromLocal(resData);
                setItem(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        loading.current = false;
    };
    React.useEffect(() => {
        if (needFetch) {
            fetchData();
        }
    }, [needFetch]);

    return [item, loading.current];
};

export default usePPAChanneld;
